/* @flow */

import { bindSelectors, memoizeSelectors } from './selectors';

import Immutable from 'immutable';

const Selectors = {
  errors: (state: Immutable.Map): Immutable.List =>
    state.get('errors'),
  successes: (state: Immutable.Map): Immutable.List =>
    state.get('successes'),
  isNotFound: (state: Immutable.Map): boolean =>
    state.get('notFound')
};

const UnboundNotificationSelectors = memoizeSelectors(Selectors);
const NotificationSelectors = bindSelectors('notification', UnboundNotificationSelectors);

export {
  NotificationSelectors,
  UnboundNotificationSelectors
};
